import * as React from 'react';

import { cn } from '../utils/cn';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-xl glass-input px-3 py-2 text-base placeholder:text-muted-foreground/60 hover:glass-surface-hover focus-visible:outline-none focus-visible:glass-input-focus disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
